/**
 * The below file is the Fire Category service which contains method for doing the API calls.
 * @author: shivam.sharma2@velsof.com
 * @date : 10-01-2023
 */

import fetch from "auth/FetchInterceptor";
import {
  Application_Json,
  Authorization_Token,
  Get_All_Fire_Category,
} from "constants/ApiConstant";
import { format } from "react-string-format";
import { AUTH_TOKEN } from "redux/constants/Auth";

const FireCategoryService = {};

//#region Method for Fire Category dropdown

/**
 * Method for getting the Fire Category dropdown
 * @param {any} param API Parameters
 * @returns Fetch Method
 */
FireCategoryService.getAllFireCategory = function () {
  return fetch({
    url: Get_All_Fire_Category,
    method: "get",
    headers: {
      "Content-Type": Application_Json,
      Authorization: format(
        Authorization_Token,
        localStorage.getItem(AUTH_TOKEN)
      ),
    },
  });
};

//#endregion Method for Fire Category dropdown.

export default FireCategoryService;
